export default __webpack_public_path__ + "static/media/iconLibrary.a1af83b6.png";